exports = module.exports = require("../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".re-star-rating[data-v-97391474] {\n  display: flex;\n  align-items: flex-start;\n}\n.re-star-rating .stars[data-v-97391474] {\n  position: relative;\n}\n.re-star-rating .stars .star[data-v-97391474] {\n  cursor: pointer;\n}\n.re-star-rating .stars .star.inactive[data-v-97391474] {\n  cursor: default;\n  pointer-events: none;\n}\n.re-star-rating .stars.partial-parent .star.partial-marked[data-v-97391474] {\n  position: absolute;\n  z-index: 1;\n  overflow: hidden;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n}", ""]);

// exports
